import type { StatusColor } from '../base/StatusToneEnum'
import { StatusToneEnum } from '../base/StatusToneEnum'
import { PublicationStatusEnum } from '../base/PublicationStatusEnum'

export type AssetStatusDetailType = { description: string; value: PublicationStatusEnum } & StatusColor

// Same tone per meaning as `libs/blog/common/src/blog/BlogStatus.ts`: Active is live, InActive is switched off,
// Draft is not ready, and Internal (staff only) has no default tone so it takes the amber custom colour.
export const AssetStatus: Record<keyof typeof PublicationStatusEnum, AssetStatusDetailType> = {
  Active: {
    value: PublicationStatusEnum.Active,
    description: 'The asset shows on the storefront.',
    tone: StatusToneEnum.Active,
  },
  InActive: {
    value: PublicationStatusEnum.InActive,
    description: 'The asset is switched off and hidden from the storefront.',
    tone: StatusToneEnum.Inactive,
  },
  Draft: {
    value: PublicationStatusEnum.Draft,
    description: 'The asset is not ready and hidden from the storefront.',
    tone: StatusToneEnum.Draft,
  },
  Internal: {
    value: PublicationStatusEnum.Internal,
    description: 'The asset is for staff only and hidden from the storefront.',
    color: 'var(--status-custom-amber)',
  },
}
